<template>
  <router-view />   
</template>